import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import { calculateOccupancyRate } from 'lumen/utils/net-revenue/metrics';
import type { NetRevenueReference } from 'lumen/utils/net-revenue/types';

export default class NetRevenueStayDatePoint extends Model {
  [Type] = 'net-revenue/stay-date-point' as const;

  @attr('number') declare capacity: number;
  @attr('net-revenue-money') declare cost: number | null;
  @attr('string') declare date: string;

  @attr('net-revenue-money') declare netRevenue: number;
  @attr('net-revenue-references') declare references: NetRevenueReference[];
  @attr('number') declare roomNights: number;
  @attr('net-revenue-money') declare roomRevenue: number;

  get occupancy(): number {
    return calculateOccupancyRate(this.roomNights, this.capacity) ?? 0;
  }

  referenceByType(type: string): NetRevenueReference | undefined {
    return this.references?.find((reference) => reference.type === type);
  }
}
